module.exports = __webpack_public_path__ + "static/media/cr1.51d57fd9.png";